module.exports = __webpack_public_path__ + "img/custom.3e2e715e.svg";